import { WidgetUnit } from 'types';
import { WidgetAction, WidgetState } from './types';

export default function widgetReducer(
  state: WidgetState,
  action: WidgetAction,
): WidgetState {
  switch (action.type) {
    case 'WIDGET_DATA_LOAD_REQUEST': {
      return { ...state, status: 'request' };
    }

    case 'WIDGET_DATA_LOAD_SUCCESS': {
      const {
        payload: { configuration, domainId, results, prId, variantId },
      } = action;
      const {
        expectedNumberOfUnits,
        hasPublisherTheme,
        showLogo,
        brandingLogo,
        titleOverride,
        aspectRatioHeight,
        aspectRatioWidth,
        imageResizeStrategy,
      } = configuration ?? {};

      const order = results?.map((r) => r.resultId);
      const data = results?.reduce(
        (acc, val) => {
          acc[val.resultId] = val;
          return acc;
        },
        {} as Record<string, WidgetUnit>,
      );

      return {
        ...state,
        domainId,
        prId,
        showLogo,
        brandingLogo,
        variantId,
        expectedNumberOfUnits:
          expectedNumberOfUnits ?? state.expectedNumberOfUnits,
        hasTheme: hasPublisherTheme,
        status: 'success',
        title: titleOverride ?? state.title,
        unitOrder: order,
        units: data,
        aspectRatioHeight: aspectRatioHeight ?? state.aspectRatioHeight,
        aspectRatioWidth: aspectRatioWidth ?? state.aspectRatioWidth,
        imageResizeStrategy: imageResizeStrategy ?? state.imageResizeStrategy,
      };
    }

    case 'WIDGET_DATA_LOAD_FAILURE': {
      return { ...state, status: 'failure' };
    }

    case 'FLAG_UNIT_FEATURE_OFF': {
      return { ...state, flagUnitFeature: false };
    }

    case 'FLAG_UNIT': {
      const { payload } = action;
      return { ...state, flaggedUnits: [...state.flaggedUnits, payload] };
    }

    default: {
      // if all action types are handled above, TS evaluates action to be `never`
      // in the default case.  ignore TS error so that we can still report on the issue
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      throw new Error(`Unhandled action type ${action?.type}`);
    }
  }
}
